//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {  },
  data () {
    return {
      // 数据示例：
      // tableConfig: {
      //   thList: [
      //     {text: '序号', width: '15%'},
      //     {text: '产品名称', width: '20%'},
      //     {text: '账面库存/扫码库存', flex: '1'},
      //   ],
      //   trList: [ 
      //   [1, '0062*************177', '单品码'],
      //   [2, '0062*************071', '单品码'],
      //   [3, '0062*************058', '单品码'],
      //   [4, '0062*************244', '单品码'],
      //   [5, '0062*************197', '单品码'],
      // ]
      // },
    }
  },
  props: ['config'],
  computed: {},
  methods: {}
}
